import { render } from "./popular.vue?vue&type=template&id=29975784&scoped=true"
import script from "./popular.vue?vue&type=script&lang=js"
export * from "./popular.vue?vue&type=script&lang=js"

import "./popular.vue?vue&type=style&index=0&id=29975784&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-29975784"

export default script